<template>
  <div class="edit-html-email-template" :class="{loaded: ' loaded'}">
    <div class="panel panel-primary panel-stretch">
      <div class="panel-heading">
        Html email template
      </div>

      <div class="panel-footer" v-if="loaded" style="overflow: auto">
        <a-button class="pull-left button-margin" @click="handleCancel" :disabled="loading">
          Annuleren
        </a-button>
        <a-button class="pull-right button-margin" type="primary" @click="handleSubmit" :disabled="loading">
          Opslaan
        </a-button>
        <a-button class="btn-primary pull-right button-margin" type="primary" @click="handleShowSendExampleEmail"
                  :disabled="loading">
          Voorbeeld e-mail versturen
        </a-button>
      </div>

      <div class="panel-body" v-if="!loaded">
        <a-icon type="loading"/>
        Het template wordt geladen...
      </div>

        <a-form-model v-else :model="form" :colon="false"
                      :label-col="labelCol"
                      :wrapper-col="wrapperCol">
          <div class="panel-body">
            <a-form-model-item label="Naam" :has-feedback="true"
                               :validate-status="hasValidationErrors(validation.name)" :help="validation.name">
              <a-input class="template-input-name mt4" :disabled="loading" v-model="form.name"
                       placeholder="Naam"
                       @change="clearValidationErrors('name')"
                       style="width: 50%"/>
            </a-form-model-item>

            <a-form-model-item label="preheader" :has-feedback="true"
                               :validate-status="hasValidationErrors(validation.pre_header)"
                               :help="validation.pre_header">
              <a-input class="template-input-pre_header mt4" :disabled="loading" v-model="form.pre_header"
                       placeholder="preheader"
                       @change="clearValidationErrors('pre_header')"
                       style="width: 50%"/>
            </a-form-model-item>

            <a-form-model-item label=" ">
                <a-alert v-for="(value, key) in cautions" :message="value" type="warning" :key="key" style="width: 50%; margin-bottom: 8px" />
                <a-alert v-for="(value, key) in errors" :message="value" type="error" :key="key" style="width: 50%; margin-bottom: 8px"/>
            </a-form-model-item>

            <a-form-model-item label="Voorbeeld">
              <a-switch v-model="showExample"  style="margin-top: 6px"/>
            </a-form-model-item>
            <HtmlEmailTemplateExample v-if="showExample" :template-content="form.content"/>

            <a-form-model-item label="HTML template">
            </a-form-model-item>
            <div style="overflow-x: scroll;">
              <prism-editor style="width:8000px" class="my-editor" v-model="form.content"
                          :highlight="highlighter" line-numbers></prism-editor>
            </div>
          </div>

          <div class="panel-footer">
            <a-form-model-item :wrapper-col="{span: 24}">
              <div>
                <a-button class="task-cancel-button pull-left button-margin" @click="handleCancel" :disabled="loading">
                  Annuleren
                </a-button>
                <a-button class="task-save-button pull-right button-margin" type="primary" @click="handleSubmit" :disabled="loading">
                  Opslaan
                </a-button>
                <a-button class="task-save-button pull-right button-margin" type="primary" @click="handleShowSendExampleEmail"
                          :disabled="loading">
                  Voorbeeld e-mail versturen
                </a-button>
              </div>
            </a-form-model-item>
          </div>
        </a-form-model>
    </div>

    <a-modal class="send-html-email-template-example-modal" width="60%" :title="'Template - ' + form.name"
             v-model="showSendExampleEmailModal">
      <template>
        <a-input class="send-example-to" :disabled="loading" v-model="sendExampleTo"
                 placeholder="E-mailadres"
                 @change="clearValidationErrors('email')"/>
      </template>
      <template slot="footer">
        <a-button @click="closeSendExampleEmailModal" type="default">
          Sluiten
        </a-button>
        <a-button @click="handleSendExampleEmail" type="default">
          Versturen
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import {PrismEditor} from 'vue-prism-editor'
import 'vue-prism-editor/dist/prismeditor.min.css' // import the styles
import {highlight, languages} from 'prismjs/components/prism-core'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/themes/prism-tomorrow.css'
import HtmlEmailTemplateExample from './ExampleComponent'
import htmlEmailTemplateApi from '~/api/html_email_template'

const moment = require('moment')

export default {
  name: 'CreateOrEditHTMLEmailTemplateComponent',
  props: {
    tags: {
      type: Array,
      default: []
    },
    templateId: {
      type: [Number, String],
      required: false,
    },
    redirectUrl: {
      type: String,
      required: false,
      default: 'settings/html_email_template'
    },
  },
  components: {
    HtmlEmailTemplateExample,
    PrismEditor
  },
  data () {
    return {
      loading: true,
      loaded: false,
      form: {},
      validation: {
        name: null,
        pre_header: null,
        email: null
      },
      showSendExampleEmailModal: false,
      sendExampleTo: '',
      showExample: false
    }
  },
  mounted () {
    this.initTemplate().then()
        .catch()
        .finally(() => {
          this.loading = false
          this.loaded = true
        })
  },
  computed: {
    cautions () {
      let cautions = {}

      for (let i = 0; i < this.tags.length; i++) {

        let tagCount = this.tagCount(this.tags[i])

        if (tagCount === 0) {
          cautions[this.tags[i]] = "De " + this.tags[i] + " komt niet voor in de template"
        } else if (tagCount > 1) {
          cautions[this.tags[i]] = "De " + this.tags[i] + " instantie staat " + tagCount + " keer in de template"
        }
      }

      return cautions
    },
    errors() {
      let errors = {};

      if (this.hasTagCountMismatch) {
        errors['tag_count'] = "Er zijn " + this.openingTagsCount + " opening tags terwijl er " + this.closingTagsCount + " closing tags zijn"
      }

      return errors
    },
    hasCautions() {
      return this.cautions.length > 0
    },
    hasContent () {
      return this.contentCount > 0
    },
    contentCount () {
      const contentRegex = /{{ \$content.*}}/ig
      let content = this.form.content || ''

      return (content.match(contentRegex) || []).length
    },
    hasTitle () {
      return this.titleCount > 0
    },
    titleCount () {
      const titelRegex = /{{ \$title.*}}/ig
      let content = this.form.content || ''

      return (content.match(titelRegex) || []).length
    },
    openingTagsCount () {
      const openingTagRegex = /<[^\/<>][^<>]*[^/]>/ig
      let content = this.form.content || ''

      return (content.match(openingTagRegex) || []).length
    },
    closingTagsCount () {
      const closingTagRegex = /<\/[^<>]*>/ig
      let content = this.form.content || ''

      return (content.match(closingTagRegex) || []).length
    },
    hasTagCountMismatch () {
      return this.openingTagsCount !== this.closingTagsCount
    },
    renderedContent () {
      const titelRegex = /{{ \$title.*}}/ig
      const contentRegex = /{{ \$content.*}}/ig
      let content = this.form.content || ''
      content = content.replaceAll(titelRegex, 'Test titel')
      content = content.replaceAll(contentRegex, 'Deze tekst staat hier ter illustratie')

      return content
    },
    labelCol () {
      switch (this.$mq) {
        case 'mobile':
          return { span: 6 }
        case 'tablet':
          return { span: 6 }
        case 'laptop':
          return { span: 6 }
        case 'desktop':
          return { span: 6 }
      }
    },
    wrapperCol () {
      switch (this.$mq) {
        case 'mobile':
          return { span: 18 }
        case 'tablet':
          return { span: 18 }
        case 'laptop':
          return { span: 18 }
        case 'desktop':
          return { span: 18 }
      }
    },
    hasTemplateId () {
      return typeof this.templateId !== 'undefined' && this.templateId !== null && this.templateId !== ''
    },
  },
  methods: {
    tagCount(tag) {
      const tagRegex = new RegExp('{{ \\$' + tag + '.* }}', "ig");
        let content = this.form.content || ''

        return (content.match(tagRegex) || []).length
    },
    highlighter (code) {
      return highlight(code, languages.js) // languages.<insert language> to return html with markup
    },
    initTemplate () {
      return new Promise((resolve, reject) => {
        if (this.hasTemplateId) {
          htmlEmailTemplateApi.get(this.templateId).then(response => {
            this.setForm(response.data)
            resolve()
          }).catch(reject)
        } else {
          this.setForm()
          resolve()
        }
      })
    },
    setForm (template = null) {
      this.form = {
        name: template ? template.name : null,
        pre_header: template ? template.pre_header : null,
        content: template ? template.content : '',
      }
      if (typeof this.templateId !== 'undefined' && this.templateId !== null) {
        this.form.id = this.templateId
      }
    },
    hasValidationErrors (input) {
      return input !== null ? 'error' : null
    },
    clearValidationErrors (field) {
      this.validation[field] = null
    },
    updateValidation (data) {
      for (const key in data) {
        this.validation[key] = data[key]
      }
    },
    handleSubmit () {
      this.loading = true
      this.hasTemplateId ? this.updateTemplate() : this.storeTemplate()
    },
    storeTemplate () {
      this.form.id = null
      htmlEmailTemplateApi.store(this.form).then(() => {
        this.$notification['success']({
          message: 'success',
          description: 'De template is opgeslagen.'
        })
        if (this.redirectUrl) {
          window.location.href = this.redirectUrl
        } else {
          this.$emit('store', this.form)
        }
      }).catch((error) => {
        if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.error !== 'undefined' && typeof error.response.data.error.errors !== 'undefined') {
          this.updateValidation(error.response.data.error.errors)
        } else {
          this.$notification['error']({
            message: 'Er ging iets mis',
            description: 'De template is niet opgeslagen.'
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    updateTemplate () {
      this.form.id = this.templateId
      htmlEmailTemplateApi.update(this.form).then(() => {
        this.$notification['success']({
          message: 'success',
          description: 'De template is opgeslagen.'
        })
        if (this.redirectUrl) {
          window.location.href = this.redirectUrl
        } else {
          this.$emit('update', this.form)
        }
      }).catch((error) => {
        if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.error !== 'undefined' && typeof error.response.data.error.errors !== 'undefined') {
          this.updateValidation(error.response.data.error.errors)
        } else {
          this.$notification['error']({
            message: 'Er ging iets mis',
            description: 'De template is niet opgeslagen.'
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleCancel () {
      if (this.redirectUrl) {
        window.location.href = this.redirectUrl
      } else {
        this.$emit('cancel')
      }
    },
    handleShowSendExampleEmail () {
      this.showSendExampleEmailModal = true
    },
    closeSendExampleEmailModal () {
      this.showSendExampleEmailModal = false
    },
    validateToAddress () {
      let regex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)

      if (!regex.test(this.sendExampleTo)) {
        return false
      }

      return true
    },
    handleSendExampleEmail () {
      if (typeof this.sendExampleTo === 'undefined' || this.sendExampleTo === '' || this.sendExampleTo === null) {
        alert('Voer een e-mailadres in')
      }

      if (!this.validateToAddress()) {
        alert('"' + this.sendExampleTo + '" is geen geldig e-mailadres')
      }

      htmlEmailTemplateApi.sendExample(this.form.content, this.sendExampleTo).then(() => {
        this.showSendExampleEmailModal = false;
        this.$notification['success']({
          message: 'success',
          description: 'Een voorbeeld is verzonden naar ' + this.sendExampleTo
        })
      }).catch((error) => {
        if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.error !== 'undefined' && typeof error.response.data.error.errors !== 'undefined') {
        } else {
          this.$notification['error']({
            message: 'Er ging iets mis',
            description: 'Kon geen voorbeeld verzenden'
          })
        }
      })
    }
  },
}
</script>
<style>
.button-margin {
  margin: 5px;
}

/* required class */
.my-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: ghostwhite;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example: */
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}
</style>
